// extracted by mini-css-extract-plugin
export var centerText = "_e6-8";
export var container = "_e6-0";
export var doughnutContainer = "_e6-7";
export var legend = "_e6-a";
export var legendItemColorDisplay = "_e6-b";
export var legendItemLabel = "_e6-d";
export var legendItemValue = "_e6-c";
export var lg = "_e6-5";
export var maxWidth = "_e6-9";
export var md = "_e6-4";
export var responsive = "_e6-6";
export var sm = "_e6-3";
export var xs = "_e6-2";
export var xxs = "_e6-1";